import { create } from "zustand";
import { IGif } from "@/common/services/types";
import { mergeGifs } from "@/common/utils/mergeGifs";

interface IGifsState {
  gifs: IGif[];
  updateGifs: (incomingGifs: IGif[]) => void;
  getGifById: (gifId: string) => IGif | undefined;
}

export const useGifStore = create<IGifsState>(
  (set, get) => ({
    gifs: [],
    updateGifs: (incomingGifs: IGif[]) =>
      set((state) => ({
        gifs: mergeGifs(state.gifs, incomingGifs),
      })),
    getGifById: (gifId: string) => {
      const { gifs } = get();

      return gifs.find((gif) => gif.id === gifId || gif.aliasId === gifId);
    },
  }),
);
